import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    keyName: String,
    hideClassName: { type: String, default: "hidden" }
  }

  connect () {
    this.element.classList.toggle(this.hideClassNameValue, this.#alreadyShown)
    this.#markShown()
  }

  get #alreadyShown() {
    return localStorage.getItem(this.keyNameValue) === "true"
  }

  #markShown() {
    localStorage.setItem(this.keyNameValue, "true")
  }
}
